/**
 * Browser Detection Utility
 * Detects the user's browser type for browser-specific instructions
 */

export type BrowserType = 'chrome' | 'edge' | 'firefox' | 'safari' | 'unknown'

/**
 * Detect browser type from user agent
 */
export const detectBrowser = (): BrowserType => {
  if (typeof window === 'undefined') return 'unknown'

  const userAgent = window.navigator.userAgent.toLowerCase()

  if (userAgent.includes('edg')) return 'edge'
  if (userAgent.includes('chrome') && !userAgent.includes('edg')) return 'chrome'
  if (userAgent.includes('firefox')) return 'firefox'
  if (userAgent.includes('safari') && !userAgent.includes('chrome')) return 'safari'

  return 'unknown'
}
